"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientConnectionType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientConnectionType_Factory = /** @class */ (function () {
    function PatientConnectionType_Factory() {
    }
    PatientConnectionType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
            InverseCode: model.InverseCode,
            InverseConnectionType: PatientConnectionType_Factory.CreateIncoming(model.InverseConnectionType),
        };
        return result;
    };
    PatientConnectionType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
            InverseCode: model.InverseCode,
            InverseConnectionType: PatientConnectionType_Factory.CreateOutgoing(model.InverseConnectionType),
        };
        return result;
    };
    return PatientConnectionType_Factory;
}());
exports.PatientConnectionType_Factory = PatientConnectionType_Factory;
